<template>
  <!-- 续期继续率统计 -->
  <div class="main-container">
    <div class="content">
      <div class="describe-box">
        <img src="@/static/images/icon-01.png" />
        <div class="desc-text">
          <span>续期数据依赖保司数据同步，可能存在延迟情况</span>
          <span class="marker" @click="$refs.ruleExplainModalRef.open()">查看续期结算规则></span>
        </div>
      </div>
      <div class="search-box btn3">
        <div class="input-item">
          <span class="label">应续费周期</span>
          <DatePicker
            type="month"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM"
            placeholder="起始月份"
            :value="searchParams.needPayDateStart"
            @on-change="dateStartChange"
          ></DatePicker>
          <span style="line-height: 30px;margin: 0 5px">至</span>
          <DatePicker
            type="month"
            :transfer="true"
            placement="bottom"
            format="yyyy-MM"
            placeholder="结束月份"
            :value="searchParams.needPayDateEnd"
            @on-change="dateEndChange"
          ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">续费年度</span>
          <Select v-model="searchParams.payNum" :transfer="true" clearable>
            <Option value="2">2</Option>
            <Option value="3">3</Option>
            <Option value="4">4</Option>
            <Option value="5">5</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">结算状态</span>
          <Select v-model="searchParams.balanceStatus" :transfer="true" clearable>
            <Option value="-1">不符合结算条件</Option>
            <Option value="0">未结算</Option>
            <Option value="1">已结算</Option>
          </Select>
        </div>
        <!-- <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div> -->
        <div class="input-item">
          <span class="label">是否达标</span>
          <RadioGroup v-model="searchParams.isReachStandard" @on-change="searchAjax()">
            <Radio label="">全部</Radio>
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </div>

        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost @click="daochu()">导出</Button>
        </div>
      </div>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <!-- 是否达标 -->
          <template slot-scope="{ row }" slot="isReachStandard">
            <span class="my-tag green" v-if="row.isReachStandard == 1">是</span>
            <span class="my-tag red" v-else>否</span>
          </template>
          <!-- 是否确认 -->
          <template slot-scope="{ row }" slot="isSure">
            <span class="my-tag green" v-if="row.isSure == 1">已确认</span>
            <span class="my-tag red" v-else>未确认</span>
          </template>
          <!-- 结算状态 -->
          <template slot-scope="{ row }" slot="balanceStatus">
            <span class="my-tag red" v-if="row.balanceStatus == -1">不符合结算条件</span>
            <span class="my-tag" v-else-if="row.balanceStatus == 0">未结算</span>
            <span class="my-tag green" v-else-if="row.balanceStatus == 1">已结算</span>
            <span class="my-tag org" v-else>结算中</span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span @click="$refs.detailModalRef.open(row)" class="table-btn">详情</span>
          </template>
        </Table>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
      </div>
    </div>

    <!-- 规则说明 -->
    <ruleExplainModal ref="ruleExplainModalRef" />
    <!-- 详情 -->
    <detailModal ref="detailModalRef" />
  </div>
</template>

<script>
import ruleExplainModal from './components/ruleExplainModal';
import detailModal from './components/detailModal';
import { pageTool } from '@/api/mixins';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, config],
  components: {
    ruleExplainModal,
    detailModal
  },
  data() {
    return {
      searchParams: {
        needPayDateStart: '',
        needPayDateEnd: '',
      }
    };
  },
  mounted() {
    this.initListParams('/buz/renewalRate/queryRenewalRateList');
  },
  activated() {
    this.getList();
  },
  methods: {
    daochu() {
      if(!this.$units.pointAction('renewalManage_05_export')){
        this.$notice.error('无权操作，请联系您的上级');
        return
      }
      if (!this.tableData.length) {
        this.$notice.msg('暂无可导出数据');
        return;
      }
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/renewalRate/exportRenewalRateList', params, 'POST');
    },
    setListParams(params) {},
    // 应续费周期 开始月份
    dateStartChange(time) { 
      this.searchParams.needPayDateStart = time;
      const params = this.searchParams;
      if(params.needPayDateEnd && params.needPayDateStart >= params.needPayDateEnd) {
        params.needPayDateEnd = params.needPayDateStart;
      }
    },
    // 应续费周期 结束月份
    dateEndChange(time) { 
      this.searchParams.needPayDateEnd = time;
      const params = this.searchParams;
      if(params.needPayDateEnd && params.needPayDateStart >= params.needPayDateEnd) {
        params.needPayDateStart = params.needPayDateEnd;
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.describe-box {
  height: 60px;
  border-radius: 4px;
  background: linear-gradient(106deg, #fff7ea 0%, #fff1e8 100%);
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  padding-left: 24px;
  img {
    width: 26px;
    height: 26px;
    margin-right: 12px;
  }
  .desc-text {
    font-size: 13px;
    color: #6e574a;
    letter-spacing: 0.6px;
  }
  .marker {
    color: #ff5f00;
    text-decoration: underline;
    letter-spacing: 1px;
    margin-left: 30px;
  }
  .marker:hover {
    cursor: pointer;
  }
}
</style>
